import { PrimaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";
import { SortEnum } from "../../../common/enums/SortEnum";
import { handleCertificateExpirySort } from "./handleCertificateExpirySort";
import { Dispatch } from "redux";

interface Props {
    sort: {
        sortName: SortEnum;
        isSorted: boolean;
    };
    dispatch: Dispatch;
    isEstablishmentManager?: boolean;
}

export const getTableColumns = (props: Props): PrimaryTableColumn[] => {
    const { isEstablishmentManager, sort, dispatch } = props;

    return [
        {
            value: "Certificaat",
            isSortable: true,
            isSorted: sort.sortName === SortEnum.QUALIFICATION_NAME_DESC,
            sortOnClick: handleCertificateExpirySort({
                sort: {
                    isSorted:
                        sort.sortName === SortEnum.QUALIFICATION_NAME_DESC,
                    sortName: SortEnum.QUALIFICATION_NAME_ASC,
                },
                dispatch,
            }),
        },
        ...(isEstablishmentManager
            ? [
                  {
                      value: "Naam",
                      isSortable: true,
                      isBold: true,
                      isSorted: sort.sortName === SortEnum.EMPLOYEE_NAME_DESC,
                      sortOnClick: handleCertificateExpirySort({
                          sort: {
                              isSorted:
                                  sort.sortName === SortEnum.EMPLOYEE_NAME_DESC,
                              sortName: SortEnum.EMPLOYEE_NAME_ASC,
                          },
                          dispatch,
                      }),
                  },
                  {
                      value: "Norm",
                      isTag: true,
                      tagColor: "#FFFFFF",
                      tagBackgroundColor: "#07A9D6",
                  },
                  {
                      value: "Opleider",
                      isSortable: true,
                      isSorted: sort.sortName === SortEnum.EDUCATOR_NAME_DESC,
                      sortOnClick: handleCertificateExpirySort({
                          sort: {
                              isSorted:
                                  sort.sortName === SortEnum.EDUCATOR_NAME_DESC,
                              sortName: SortEnum.EDUCATOR_NAME_ASC,
                          },
                          dispatch,
                      }),
                  },
              ]
            : []),
        {
            value: "Verloopt op",
            isSortable: true,
            isSorted: sort.sortName === SortEnum.EXPIRY_DATE_DESC,
            sortOnClick: handleCertificateExpirySort({
                sort: {
                    isSorted: sort.sortName === SortEnum.EXPIRY_DATE_DESC,
                    sortName: SortEnum.EXPIRY_DATE_ASC,
                },
                dispatch,
            }),
        },
    ];
};
